import type {ForestMassSpeciesRepository} from '@/domain/interfaces/ForestMassSpeciesRepository';

export class GetForestMassSpeciesByForestMassUuidUseCase {
  constructor(private readonly repository: ForestMassSpeciesRepository) {}
  async execute(uuid: string) {
    return this.repository.getByForestMassUuid(uuid);
  }
}
